/**
 * Centralized API configuration
 *
 * Works across local development, Firebase Hosting, and Vercel deployment.
 */

// Detect if we are running on localhost
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]'
);

// Detect if running on Vercel
const isVercel = Boolean(
    window.location.hostname.includes('vercel.app')
);

// Base URL for the backend server (without /api suffix)
// Vercel: Uses same domain (relative path)
// Firebase/Cloud Run: Uses the Cloud Run URL
// Development: localhost:8000
let BACKEND_URL;

if (isLocalhost) {
    BACKEND_URL = 'http://127.0.0.1:8000';
} else if (isVercel) {
    // On Vercel, API is on same domain
    BACKEND_URL = '';
} else {
    // Force direct Cloud Run connection for Firebase Hosting domains
    // to bypass CDN routing/caching issues with rewrites
    BACKEND_URL = 'https://predict-claw-backend-395354291800.us-central1.run.app';
}

export { BACKEND_URL };

// Full API URL
export const API_BASE_URL = `${BACKEND_URL}/api`;

export default API_BASE_URL;
